import { ReactElement } from 'react';
import { differenceInDays } from 'date-fns';
import { SelectionState } from './types';
import { SegmentSpan } from './SegmentSpan';

type SegmentProps = {
  intervalStart: Date;
  dayWidth: number;
  selectionState: SelectionState;
};

export function Selection({ intervalStart, dayWidth, selectionState }: SegmentProps): ReactElement | null {
  if (selectionState?.type !== 'selection') {
    return null;
  }
  const { start, end, error } = selectionState;
  const left = differenceInDays(start, intervalStart) * (dayWidth + 1);
  const days = differenceInDays(end, start) + 1;
  const width = days * (dayWidth + 1);

  return (
    <SegmentSpan state="selection" left={left} width={width} start={start} end={end} error={error}>
      {days}d
    </SegmentSpan>
  );
}
